import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { QtyStepperComponent } from './qty-stepper.component';

@NgModule({
  imports: [
    CommonModule, IonicModule
  ],
  exports: [QtyStepperComponent],
  declarations: [QtyStepperComponent]
})
export class QtyStepperModule { }
